module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAkBAMAAAAEDBViAAAAAXNSR0IB2cksfwAAABtQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlFHiIAAAAAl0Uk5TAEDvUP9g8N/gQbP/sgAAAFBJREFUeJxjYEAGQsoMWIGKSwBW8RQXV6ziJi7YNbC64NAQMmI1iLtgA64MJVjFnYBBjg24MUjgMId4h+Jy5whSjivdquCIwRQc+UIsGcYCAKF/NmK4ozooAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/right-arrow@2x.png
// module id = 896
// module chunks = 0